import React, { useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";

import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { ReactComponent as NoCardIcon } from "../../assets/img/icon_add_a_card.svg"
import { primaryIconColor } from "../../style.scss"
import { loginToApp } from "../../redux-services/actions/actions.js";


const useStyles = makeStyles(themeStyle);

export function NoCardLinked(props) {
  const pageState = useLocation().state;
  const fromScreen = pageState.fromScreen;

  const history = useHistory();
  const classes = useStyles();

  const linkCard = () => {
    history.push({
      pathname: '/pages/card-on-file',
      state: { ...pageState }
    });
  }

  const backToHome = useCallback(() => {
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.noCardLinkedHandler(appData);
    history.replace({
      pathname: '/pages/dashboard'
    });
  },[history, props])

  const returnScreenName = (screenCode) => {
    switch (screenCode) {
      case 'BUYAIRTIMEDATA': 
        return 'Airtime Data';
      case 'BUYELECTRICITY':
        return 'Electricity';
      case 'AIRTIMEDATA':
        return 'Airtime Data';
      case 'COLLECTIONS':
        return 'Collections';
      case 'VAS':
        return 'Buy';
      case 'PAYBILL':
        return 'Pay Bill';
      case 'TOPUP':
        return 'Top-up';
      case 'QRSCAN':
        return 'Scan QR';
      default:
        return 'Home';
    }
  }

  const goToBack = useCallback(() => {
    if (fromScreen === 'AIRTIMEDATA' || fromScreen === 'BUYAIRTIMEDATA' || fromScreen === 'BUYELECTRICITY') {
      history.push({
        pathname: '/pages/vas-buy-airtime-data',
        state: { ...pageState }
      });
    } else if (fromScreen === 'COLLECTIONS') {
      history.push({
        pathname: '/pages/vas-buy-kganya-products',
        state: { ...pageState }
      });
    } else if (fromScreen === 'PAYBILL') {
      history.push({
        pathname: '/pages/vas-pay-bill',
        state: { ...pageState }
      });
    } else if (fromScreen === 'QRSCAN') {
      history.push({
        pathname: '/pages/pay-amount',
        state: { ...pageState }
      });
    } else if (fromScreen === 'TOPUP') {
      history.push({
        pathname: '/pages/topup',
        state: { ...pageState }
      });
    } else {
      backToHome();
    }
  }, [fromScreen, history, pageState, backToHome]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToHome();
      }
    };
  }, [backToHome])

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              <NoCardIcon stroke={primaryIconColor} fill={primaryIconColor} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <h5 className={classes.textCenter + ' m-t-0 m-b-0'}><b>You don't have a linked bank <br /> card yet.</b></h5>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0'}><b>Securely link your Mastercard or Visa bank card to pay QR codes, bills or buy airtime and data.</b></p>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="transparent" type="button" onClick={goToBack} >Back {fromScreen ? 'to ' + returnScreenName(fromScreen) : ''}</Button>
            </GridItem>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="button" onClick={linkCard}>Link bank card</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  noCardLinkedHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(NoCardLinked)